module.exports = __webpack_public_path__ + "media/images/teams/SPAL-fd96227332a218484b4885f90685b702.png";